import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { WelcomePinTrigger } from "web_myplann/Goals/Components/GoalPinningSection";

type WelcomePinLocationState = {
	welcomePin?: boolean;
	ownFunds?: number;
};

type WelcomePin = {
	welcomePinOpen: boolean;
	welcomePinOwnFunds: number;
	welcomePinTrigger: WelcomePinTrigger | null;
	closeWelcomePin: () => void;
	assignWelcomePin: () => void;
	clearWelcomePinTrigger: () => void;
	triggerWelcomePin: (hasOwnFunds: boolean) => void;
};

export const useWelcomePin = (): WelcomePin => {
	const location = useLocation();
	const navigate = useNavigate();

	const [welcomePinOpen, setWelcomePinOpen] = useState(false);
	const [welcomePinOwnFunds, setWelcomePinOwnFunds] = useState(0);
	const [welcomePinTrigger, setWelcomePinTrigger] =
		useState<WelcomePinTrigger | null>(null);

	useEffect(() => {
		const state = location.state as WelcomePinLocationState | null;
		if (state?.welcomePin) {
			setWelcomePinOwnFunds(state.ownFunds ?? 0);
			setWelcomePinOpen(true);
			navigate(location.pathname, { replace: true, state: null });
		}
	}, [location.state, location.pathname, navigate]);

	const triggerWelcomePin = (hasOwnFunds: boolean) =>
		setWelcomePinTrigger({ hasOwnFunds });

	const assignWelcomePin = () => {
		setWelcomePinOpen(false);
		triggerWelcomePin(welcomePinOwnFunds > 0);
	};

	return {
		welcomePinOpen,
		welcomePinOwnFunds,
		welcomePinTrigger,
		closeWelcomePin: () => setWelcomePinOpen(false),
		assignWelcomePin,
		clearWelcomePinTrigger: () => setWelcomePinTrigger(null),
		triggerWelcomePin,
	};
};
